module.exports = __webpack_public_path__ + "static/enterprise-award-cert-1dd56b6fad4dc8d1d1c613b6601c05d1.jpeg";